import { DatePicker, Form, Radio } from "antd";

export default function UserMemberForm({ form }: any) {
    // 处理dueDate变化时的逻辑
    const onDueDateChange = (date: any) => {
        if (date) {
            form.setFieldsValue({ permanent: false });
        }
    };

    // 处理permanent变化时的逻辑
    const onPermanentChange = (e: any) => {
        if (e.target.value === true) {
            form.setFieldsValue({ dueDate: null });
        }
    };

    return (
        <Form
            form={form}
            name="UserMemberForm"
            className='user-member-form'
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            autoComplete="off"
        >
            <Form.Item
                label="会员到期时间"
                name="dueDate"
                rules={[
                    {
                        validator: (_, value) => {
                            const permanent = form.getFieldValue('permanent');
                            if (!value && !permanent) {
                                return Promise.reject('会员到期时间与永久会员至少填写一个');
                            }
                            return Promise.resolve();
                        }
                    }
                ]}
            >
                {/* 如果选择之前的时间就是代表取消后台设置的会员 */}
                <DatePicker
                    style={{ width: '100%' }}
                    placeholder="请选择会员到期时间"
                    format="YYYY-MM-DD"
                    onChange={onDueDateChange}
                />
            </Form.Item>

            <Form.Item
                label="永久会员"
                name="permanent"
                rules={[
                    {
                        validator: (_, value) => {
                            const dueDate = form.getFieldValue('dueDate');
                            if (!value && !dueDate) {
                                return Promise.reject('会员到期时间与永久会员至少填写一个');
                            }
                            return Promise.resolve();
                        }
                    }
                ]}
            >
                <Radio.Group onChange={onPermanentChange}>
                    <Radio value={true}>是</Radio>
                    <Radio value={null}>否</Radio>
                </Radio.Group>
            </Form.Item>
        </Form>
    )
}
